// extracted by mini-css-extract-plugin
module.exports = {"hreset":"indicadores_hreset__qif0c"};